import { formatDNI } from '@chilecompra/react-kit'
const radioOptions = [
  { label: 'No', value: '2' },
  { label: 'Si', value: '1' }
]
const leyUrl = 'https://www.bcn.cl/leychile/navegar?idNorma=213004&idParte=8649149'
const sqlInjectionPattern = /(\b(SELECT|DROP|INSERT|DELETE|UPDATE|UNION|WHERE)\b.*['";])|(--|\/\*|\*\/|=)/i

const isValidSQLInput = value => {
  if (value?.length < 3) return 'Debe tener al menos 3 caracteres.'
  if (/<|>/.test(value)) return 'Caracteres invalidos.'
  if (/['";]/.test(value) && sqlInjectionPattern.test(value)) {
    return 'Entrada peligrosa detectada.'
  }

  return null
}

const columns = [
  {
    name: 'RUT o Cédula de identidad',
    formatter: formatDNI,
    validator: value => {
      if (value?.length < 11) return 'Verificar cantidad de caracteres.'
      return null
    },
    value: 'rut',
    maxLength: 12
  },
  {
    name: 'Nombre o razón social',
    validator: isValidSQLInput,
    value: 'razonSocial',
    maxLength: 50
  }
]

const DESCRIPTION_DICTIONARY = {
  UNKNOWN: 'UNKNOWN_ERROR',
  UNAUTHORIZED: 'UNAUTHORIZED_ERROR'
}

export { radioOptions, leyUrl, columns, DESCRIPTION_DICTIONARY }
